@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.zones

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.zones.PriceZoneDto

object GetPriceZonesEndpoint : EndPoint<GetPriceZonesEndpoint.Request, GetPriceZonesEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String?,
    )

    class Response(
        val list: Array<PriceZoneDto>,
        val total: Int,
    )
}
